import React from 'react'

import BaseAssemblyFormBlock from './BaseAssemblyFormBlock'

const MortgageRefinanceFormBlock = () => {
  return <BaseAssemblyFormBlock formId='4967224' height='600' />
}

export default React.memo(MortgageRefinanceFormBlock)
